export const orderResource = [
  { label: '乘客订票', value: '1' },
  { label: '代理商订票', value: '4' },
  { label: '中央订票', value: '2' },
  { label: '司机补票', value: '5' },
  { label: '第三方接口订票', value: '6' },
  { label: '云闪付', value: '99' }
]
